import { releaseVersion, clientName, isCypress, isOfflinePlayer, isStorybook, isRenderer } from "js/config";

import { browserId, sessionId } from "js/core/browserAndSession";
import Logger from "js/core/logger/Logger";
import ApiTransport from "js/core/logger/transports/ApiTransport";
import ConsoleTransport from "js/core/logger/transports/ConsoleTransport";
import { LogEntryContext, LoggerTransportContext, LogGroup } from "js/core/logger/types";
import { auth } from "js/firebase/auth";

// Transports we use
const transportContext: LoggerTransportContext = {
    sessionId,
    browserId,
    clientName,
    clientVersion: releaseVersion,
    userAgent: navigator.userAgent
};

const transports = [new ConsoleTransport(transportContext)];
if (!isOfflinePlayer && !isCypress && !isStorybook && !isRenderer) {
    transports.push(new ApiTransport(transportContext));
}

// Custom entries context generator
function getLogEntryContext(): LogEntryContext {
    return {
        uid: isOfflinePlayer ? undefined : auth().currentUser?.uid,
        location: window.location.origin + window.location.pathname,
    };
}

// Loggers, will be lazy initialized (except for window logger)
const loggers: Partial<Record<LogGroup, Logger>> = {
    [LogGroup.WINDOW]: new Logger(transports, getLogEntryContext, LogGroup.WINDOW)
};

/**
 * Returns a logger for the specified logging group
 */
function getLogger(group: LogGroup = LogGroup.DEFAULT) {
    if (!loggers[group]) {
        loggers[group] = new Logger(transports, getLogEntryContext, group);
    }

    return loggers[group];
}

export default getLogger;

export {
    getLogger,
    LogGroup
};
